/**
 * Home page FAQ content.
 *
 * CommonJS on purpose: the build-time SEO script requires this to emit FAQPage structured data, so
 * the questions Google shows and the ones on the page can never drift apart.
 */
const FAQ_ITEMS = [
  {
    id: 'what-is',
    question: 'What is XMARKET?',
    answer:
      'XMARKET is a premium player-to-player (P2P) marketplace. We safely connect gamers globally to buy and sell gaming accounts, in-game currency, items, and services across all your favorite titles.',
  },
  {
    id: 'safe',
    question: 'Is it safe to trade on XMARKET?',
    answer:
      'Absolutely. Every transaction is protected by our secure Escrow system. When you make a purchase, XMARKET holds the funds securely and only releases them to the seller once you have received your item and confirmed the delivery.',
  },
  {
    id: 'why-us',
    question: 'Why should I choose XMARKET over other marketplaces?',
    answer:
      'We offer some of the most competitive fees in the industry—meaning buyers pay less and sellers keep more of their profits. Combine that with our rigorous fraud protection, instant delivery options, and live support, and you get the best trading experience available.',
  },
  {
    id: 'seller',
    question: 'How do I become a seller?',
    answer:
      'Getting started is simple! Create a free account, complete our quick verification process (to keep our marketplace safe), and you can instantly start setting up your shop and listing your digital assets.',
  },
  {
    id: 'delivery',
    question: 'How long does delivery take after I buy something?',
    answer:
      "Delivery times vary by seller and product type. Many digital items and accounts feature 'Instant Delivery' and are sent to you immediately upon purchase. For in-game currency or boosting, sellers typically deliver within the guaranteed timeframe listed on their offer.",
  },
  {
    id: 'payout',
    question: 'When do sellers get paid?',
    answer:
      "Sellers receive their funds into their XMARKET balance as soon as the buyer confirms delivery, or automatically after the buyer's inspection period expires. From there, you can easily withdraw your earnings using our fast, supported payout methods.",
  },
  {
    id: 'payments',
    question: 'What payment methods do you accept?',
    answer:
      'We support a wide variety of global payment options to make trading easy for everyone. This includes major Credit/Debit cards, Apple & Google Pay, popular cryptocurrencies, Cash App, and other local payment methods.',
  },
  {
    id: 'wrong',
    question: 'What happens if something goes wrong with my order?',
    answer:
      "You are fully protected. If a seller fails to deliver or the item isn't as described, you can easily open a dispute on the order page. Our 24/7 dispute moderation team will review the transaction and issue a prompt refund if the terms weren't met. You can also reach out via our tickets or email for immediate help.",
  },
];

module.exports = { FAQ_ITEMS };
